import { createStore } from "vuex";
import { Company } from "~/context/Company/domain/Company";
import whatsappModule from './modules/whatsapp.js';


const store = createStore({
  state: {
    lastClickTime: 0,
    inUseCompany: null,
    inUseCompanyHasTaxAgency: null,
    inUseCompanyHasAccount: null,
    inUseCompanyHasEmployees: null,
    inUseCompanyHasActiveSubscription: null,
    userExtended: null,
    userCompanies: new Map<string, any>(),
    expandMenu: false,
    dialog: false,
    updateSII: false,
    updateBank: false,
    updateReconciliation: false,
    windowSize: '',
    message: '',
    showLarge: true,
    reloadMenu: false,
    errorConnection: false,
    menuSelection: {
      movementsAll: false,
      movements: false,
      company: false,
      invoices: false,
      documents: false,
      outcomes: false,
      incomes: false,
      reconciliations: false,
      clients: false,
      providers: false,
      collaborators: false,
      employees: false,
      test: false,
    },
    dataSetup: {
      taxAgency: false,
      account: false,
    },
    employeeParams: {
      date: null,
    },
    welcomeParams: {
      firstName: '',
      lastName: '',
      gen: '',
      email: '',
      legalId: '',
      companyName: '',
      companyEmail: '',
      companyPhone: '',
      country: '',
    },
    notification: {
      show: false,
      message: '',
      duration: 1000,
    }
  },
  getters: {
    getInUseCompany(state: any) {
      return state.inUseCompany;
    },
    getInUseCompanyData(state: any) {
      const myCompanies = state.userExtended?.companies;
      //console.log("myCompanies:" + JSON.stringify(myCompanies));
      return myCompanies?.find((company: Company) => company.uid === state.inUseCompany);
    },
    getUserExtended(state: any) {
      return state.userExtended;
    },
    getUserCompanies(state: any) {
      return state.userCompanies;
    },
    getExpandMenu(state: any) {
      return state.expandMenu;
    },
    getMenuSelection(state: any) {
      return state.menuSelection;
    },
    getReloadMenu(state: any) {
      return state.reloadMenu;
    },
    getInUseCompanyHasTaxAgency(state: any) {
      //return state.inUseCompanyHasTaxAgency;
      const myCompanies = state.userExtended?.companies;
      const myuseCompany = myCompanies?.find((company: Company) => company.uid === state.inUseCompany)
      return myuseCompany?.company_hasTaxAgency;
    },
    getInUseCompanyHasAccount(state: any) {
      const myCompanies = state.userExtended?.companies;
      const myuseCompany = myCompanies?.find((company: Company) => company.uid === state.inUseCompany)
      return myuseCompany?.company_hasAccount;
    },
    getInUseCompanyHasActiveSubscription(state: any) {
      const myCompanies = state.userExtended?.companies;
      const myuseCompany = myCompanies?.find((company: Company) => company.uid === state.inUseCompany)
      //console.log("\n\n********\n\nmyuseCompany:" + JSON.stringify(myuseCompany));
      return myuseCompany?.company_hasActiveSubscription;
    },
    getInUseCompanyHasEmployees(state: any) {
      return state.inUseCompanyHasEmployees;
    },
    getWelcomeParams(state: any) {
      return state.welcomeParams;
    },
    getEmployeeParams(state: any) {
      return state.employeeParams;
    },
    getDataSetup(state: any) {
      return state.dataSetup;
    },
    getUpdateSII(state: any) {
      return state.updateSII;
    },
    getUpdateBank(state: any) {
      return state.updateBank;
    },
    getUpdateReconciliation(state: any) {
      return state.updateReconciliation;
    },
    getWindowSize(state: any) {
      return state.windowSize;
    },
    getShowLarge(state: any) {
      return state.showLarge;
    },
    getErrorConnection(state: any) {
      return state.errorConnection;
    },

  },
  mutations: {
    updateLastClickTime(state: any, value: any) {
      console.log("updateLastClickTime:" + value);
      state.lastClickTime = value;
    },
    setMenuSelection(state: any, value: any) {
      state.menuSelection = value;
    },
    setReloadMenu(state: any, value: any) {
      state.reloadMenu = value;
    },
    setExpandMenu(state: any, value: any) {
      state.expandMenu = value;
    },
    setUserExtended(state: any, value: any) {
      state.userExtended = value;
    },
    setUserCompanies(state: any, value: any) {
      state.userCompanies = value;
    },
    setInUseCompany(state: any, value: any) {
      //  console.log("value COMPANY:" + JSON.stringify(value));
      state.inUseCompany = value;
    },
    setInUseCompanyHasTaxAgency(state: any, value: any) {
      const myCompanies = state.userExtended?.companies;
      const myuseCompany = myCompanies?.find((company: Company) => company.uid === state.inUseCompany)
      myuseCompany.company_hasTaxAgency = value;
      state.inUseCompanyHasTaxAgency = value;
    },
    setInUseCompanyHasAccount(state: any, value: any) {
      const myCompanies = state.userExtended?.companies;
      const myuseCompany = myCompanies?.find((company: Company) => company.uid === state.inUseCompany)
      if(myuseCompany){
      myuseCompany.company_hasAccount = value;
      state.inUseCompanyHasAccount = value;

      }
    },
    setInUseCompanyHasActiveSubscription(state: any, value: any) {
      console.log("setInUseCompanyHasActiveSubscription:" + value);
      const myCompanies = state.userExtended?.companies;
      const myuseCompany = myCompanies?.find((company: Company) => company.uid === state.inUseCompany)
      myuseCompany.company_hasActiveSubscription = value;
      state.inUseCompanyHasActiveSubscription = value;
    },
    setInUseCompanyHasEmployees(state: any, value: any) {
      state.inUseCompanyHasEmployees = value;
    },
    setWelcomeParams(state: any, value: any) {
      state.welcomeParams = value;
    },
    setEmployeeParams(state: any, value: any) {
      state.employeeParams = value;
    },
    setDataSetup(state: any, value: any) {
      state.dataSetup = value;
    },
    setUpdateSII(state: any, value: any) {
      state.updateSII = value;
    },
    setUpdateBank(state: any, value: any) {
      state.updateBank = value;
    },
    setUpdateReconciliation(state: any, value: any) {
      state.updateReconciliation = value;
    },
    setWindowSize(state: any, value: any) {
      state.windowSize = value;
      //si value es xs, sm o m setea el valor en false
      if (value === 'xs' || value === 'sm' || value === 'm') {
        state.showLarge = false;
      } else {
        state.showLarge = true;
      }

    },
    setErrorConnection(state: any, value: any) {
      state.errorConnection = value;
    },
    addUserCompanyAccount(state: any, value: any) {
      
      if (
        value.length > 0 &&
        !state.userCompanies.has(value[0].company_uid.toString())
      ) {
        state.userCompanies.set(value[0].company_uid.toString(), value);

        state.userExtended.companies.forEach((company: any) => {
          if (company.uid.toString() === value[0].company_uid.toString()) {
            company.company_hasAccount = true;
          }
        });


      }
    },
  },
  actions: {
    reloadComponent(context) {
      context.commit("updateLastClickTime", Date.now());
    },
    resetMenuSelection(context) {
      context.commit("setMenuSelection", {
        movementsAll: false,
        movements: false,
        company: false,
        invoices: false,
        documents: false,
        outcomes: false,
        incomes: false,
        reconciliations: false,
        clients: false,
        providers: false,
        collaborators: false,
        employees: false,
        test: false,
      });
    },
    closeDialog(context) {
      context.state.dialog = false;
      context.state.message = '';
    },
    openDialog(context, message) {
      context.state.dialog = true;
      context.state.message = message;
    },
    openNotification(context, options) {
      context.state.notification.show = true;
      context.state.notification.message = options.message;
      context.state.notification.duration = options.duration;
      setTimeout(() => {
        context.state.notification.show = false;
        context.state.notification.message = '';
      }, options.duration);
    },
    openError(context, options) {
      context.state.notification.show = true;
      context.state.notification.message = options.message;
      context.state.notification.duration = options.duration;
      setTimeout(() => {
        context.state.notification.show = false;
        context.state.notification.message = '';
      }, options.duration);
    },
  },
  modules: {
    whatsapp: whatsappModule,
  },
});

export default store;
